import React from 'react';
import * as DatePickerTypesUI from '../DatePickerTypesUI';
import EditableLabel from './EditableLabel';
import { dateStringValidation } from '../../validation';
import {
  convertDisplayDateFormatToInternalDateFormat,
  convertInternalDateFormatToDisplayDateFormat,
} from '../../utils';
import { IDatePickerProps } from './types';
import { theme } from '../../../../../styles/theme';
import * as BuilderUI from '../../../BuilderUI';

const DatePickerFixed = ({
  datePicker,
  onChange,
}: IDatePickerProps<'DatePickerFixed'>) => (
  <DatePickerTypesUI.BetweenRow>
    <DatePickerTypesUI.Row>
      <BuilderUI.InputLabel>Start</BuilderUI.InputLabel>
      <EditableLabel
        value={convertInternalDateFormatToDisplayDateFormat(datePicker.start)}
        onSubmit={(newDate) =>
          onChange({
            __typename: 'DatePickerFixed',
            start: convertDisplayDateFormatToInternalDateFormat(newDate),
            end: datePicker.end,
          })
        }
        size="small"
        fontColor={theme.colors.mainBlue}
        validation={dateStringValidation}
      />
    </DatePickerTypesUI.Row>
    <DatePickerTypesUI.Row>
      <BuilderUI.InputLabel>End</BuilderUI.InputLabel>
      <EditableLabel
        value={convertInternalDateFormatToDisplayDateFormat(datePicker.end)}
        onSubmit={(newDate) =>
          onChange({
            __typename: 'DatePickerFixed',
            start: datePicker.start,
            end: convertDisplayDateFormatToInternalDateFormat(newDate),
          })
        }
        size="small"
        fontColor={theme.colors.mainBlue}
        validation={dateStringValidation}
      />
    </DatePickerTypesUI.Row>
  </DatePickerTypesUI.BetweenRow>
);

export default DatePickerFixed;
